import { useEffect, useState } from 'react';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';

// Org-ens biler, sortert på skiltnummer. Bare admin og dispatcher har lesetilgang (se firestore.rules).
export function useOrgVehicles(orgId) {
  const [state, setState] = useState({ vehicles: [], loading: Boolean(orgId), error: false });

  useEffect(() => {
    if (!orgId) {
      setState({ vehicles: [], loading: false, error: false });
      return undefined;
    }
    return onSnapshot(
      query(collection(db, 'orgVehicles'), where('orgId', '==', orgId)),
      snap => setState({
        vehicles: snap.docs
          .map(d => ({ id: d.id, ...d.data() }))
          .sort((a, b) => String(a.registrationPlate ?? '').localeCompare(String(b.registrationPlate ?? ''))),
        loading: false,
        error: false,
      }),
      () => setState({ vehicles: [], loading: false, error: true }),
    );
  }, [orgId]);

  return state;
}
